/** The PropertiesPanelShowHideButtonEvent is dispatched when the user presses the button that shows or hides the properties panel. */
export default class PropertiesPanelShowHideButtonEvent extends Event {
	/**
	 * The static CLICKED type is dispatched when the button is clicked or while focused, the Space or Enter key is pressed.
	 *
	 * Example: addEventListener(PropertiesPanelShowHideButtonEvent.CLICKED, (event: PropertiesPanelShowHideButtonEvent) => {});
	 */
	public static CLICKED = 'PropertiesPanelShowHideButtonEvent.clicked';

	public constructor() {
		super(PropertiesPanelShowHideButtonEvent.CLICKED, { bubbles: true });
	}
}
